import React from "react";
import {TableCell} from '@aws-amplify/ui-react';

function VmafCell(props) {
  return (
      <>
        <TableCell className="synamedia-td">
          {
            props.distorted ?
                props.distorted.metric_vmaf
                :
                ''
          }
        </TableCell>
      </>
  );
}

export default VmafCell;
